import { Button, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { getProductUnitTypes, postProductUnitType, updateProductUnitType } from "../../../../api/productUnitType";
import { alertError } from "../../../../utils/logger";
import EntityInfoDialog from "../../../components/dialogs/EntityInfoDialog";
import CreateProductCatalogDialog from "../../../components/dialogs/CreateProductCatalogDialog";
import Table, { buttonsStyle } from "../../../components/tables/table";
import ProductUnitTypeContent from "./ProductUnitTypeContent";

function getData(productUnitTypes) {
	let data = [];
	for (let i = 0; i < productUnitTypes.length; ++i) {
		const elem = {};
		const productUnitType = productUnitTypes[i];

		elem.descripcion = productUnitType?.descripcion;
		elem.id = productUnitType?.id;

		data = data.concat(elem);
	}
	return data;
}

export default function ProductUnitTypesPage() {
	const [data, setData] = useState([]);
	const [selectedProductUnitType, setSelectedProductUnitType] = useState(
		null
	);

	const [
		openProductUnitTypeInfoDialog,
		setOpenProductUnitTypeInfoDialog,
	] = useState(null);
	const [openCreateUnitDialog, setOpenCreateUnitDialog] = useState(false);
	const [unitToEdit, setUnitToEdit] = useState(null);

	const [refresh, setRefresh] = useState(false);

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Editar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={(e) => {
							e.stopPropagation();
								setUnitToEdit(elem);
								setOpenCreateUnitDialog(true);
						}}
					>
						<EditIcon />
					</Button>
				</Tooltip>
			</>
		);
	}

	const columns = [
		{ dataField: "descripcion", text: "Descripción", sort: true },
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getProductUnitTypes(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage:
						"No se han podido obtener los tipos de unidad de productos.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Tipos de unidades productos">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => {
								setUnitToEdit(null);
								setOpenCreateUnitDialog(true);
							}}
						>
							Nueva unidad
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table
						data={getData(data)}
						columns={columns}
						rowEvents={{
							onClick: (e, row, rowIndex) => {
								const productUnitType = data?.find(
									(x) => x.id === row.id
								);
								setSelectedProductUnitType(productUnitType);
								setOpenProductUnitTypeInfoDialog(true);
							},
						}}
					/>
					<EntityInfoDialog
						title={
							"Tipo de unidad de producto: " +
							selectedProductUnitType?.descripcion
						}
						open={openProductUnitTypeInfoDialog}
						setOpen={setOpenProductUnitTypeInfoDialog}
						content={
							<ProductUnitTypeContent
								productUnitType={selectedProductUnitType}
							/>
						}
					/>
					<CreateProductCatalogDialog
						open={openCreateUnitDialog}
						setOpen={setOpenCreateUnitDialog}
						title={unitToEdit ? "Editar tipo de unidad" : "Nueva unidad"}
						entityToEdit={unitToEdit}
						fields={[
							{ name: "descripcion", label: "Descripción", required: true },
						]}
						saveEntity={(unit, token) => unitToEdit
							? updateProductUnitType(unitToEdit.id, unit, token)
							: postProductUnitType(unit, token)}
						successMessage={unitToEdit ? "Cambios guardados con éxito." : "Tipo de unidad creado con éxito."}
						errorMessage={unitToEdit ? "No se han podido guardar los cambios." : "No se ha podido crear el tipo de unidad."}
						onSaved={() => {
							setUnitToEdit(null);
							setRefresh(true);
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
